import styled from "styled-components";

export const MobileSolutionWrapper = styled.div`
  height: 100dvh;
  box-sizing: border-box;
  padding: 58px 16px 100px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const MobileSolutionHeader = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  border: 0.93px solid #d9d9d9;
  box-shadow: 0px 3.71px 3.71px 0px #00000040;

  > .date {
    width: 100%;
    height: 50px;
    angle: 0 deg;
    opacity: 1;
    background: #7f25fb;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 23.16px;
    line-height: 50px;
    text-align: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;

export const MobileSolutionFinancial = styled.div`
  display: flex;
  padding: 10px;
  gap: 30px;

  > .icon {
    width: 83px;
    height: 83px;
    border-radius: 20px;
    background: #ecf0f3;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileSolutionFinancialText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 23.16px;
  color: #121212;

  > .purple {
    color: #7f25fb;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 30px;

    > span {
      font-size: 23.16px;
      color: #121212;
    }
  }

  > .red {
    color: #ff0000;
    font-family: Pretendard;
    font-weight: 700;
    font-size: 30px;

    > span {
      font-size: 23.16px;
      color: #121212;
    }
  }
`;
